// src/components/LandingPage/LandingPage.tsx
import Header from "../../components/LandingPage/Navbar";
import Hero from "../../components/LandingPage/Hero";
import ChooseYourQuest from "../../components/LandingPage/ChooseYourQuest";
import InnovationDNA from "../../components/LandingPage/Innovation";
import InnovationJourney from "../../components/LandingPage/InnovationJourney";
import Footer from "../../components/LandingPage/Footer";

import { questCards } from "../../components/LandingPage/data";
import Navbar from "../../components/LandingPage/Navbar";

export default function LandingPage() {
  return (
    <div className="bg-white relative w-full min-h-screen">
      <Navbar />
      <Hero/>
      <ChooseYourQuest cards={questCards} />
      <InnovationDNA />
      <InnovationJourney />
      <Footer />
    </div>
  );
}
